import styled from "styled-components";
import Table from "../DataTable";
import ListWithPagination from "../ListsWithPagination";
import { getFormattedDate } from "../getFormattedDate";
import LinkTextModal from "../LinkTextModal";
import ListWithPaginationTicket from "./ListWithPaginationTicket";
import ViewModal from "./ViewModal";
import { TableWithPagination } from "../TableWithPagination";
import TicketCarousel from "./TicketCarousal";
import TicketCarouselModal from "./TicketCarousalModal";
import { getQRCode } from "../../services/lwwTicketServices";

interface Props {
    data: any;
    isTableDataLoading: boolean;
    totalProducts: number;
    limit: number;
    onPageChange: any;
    currentPage: number;
}
const LwwTicketTable = ({ data, isTableDataLoading, totalProducts, limit, onPageChange, currentPage }: Props) => {
    const hasTransactionOrderId = data.some((item: any) => item.transaction && item.transaction.orderId);
    const columns = [
        {
            path: "booked_by",
            label: "Booked by",
            content: (data: any) => (
                <DoubleRowContainer width="5rem">
                    <span>{data.user.name}</span>
                </DoubleRowContainer>
            ),
        },
        {
            path: "contact",
            label: "Contact",
            content: (data: any) => (
                <DoubleRowContainerContact width="14rem">
                    <MobileContainer>
                        <span>{data.user.countryCode}</span>
                        <span>{data.user.phone}</span>
                    </MobileContainer>
                    <span>{data.user.email}</span>
                </DoubleRowContainerContact>
            ),
        },
        {
            path: "updatedAt",
            label: "Booking Date",
            content: (data: any) => (
                <DoubleRowContainer width="100%" maxWidth="15rem">
                    {getFormattedDate(data?.updatedAt, "YYYY-MM-DD")}
                </DoubleRowContainer>
            ),
        },
        {
            path: "bookingDate",
            label: "Visit Date",
        },
        {
            path: "qr",
            label: "Ticket",
            content: (data: any) => (
                <TicketCarouselModal ticketData={data.items} id={data._id} />
            ),
        },
        {
            path: "ticketNo",
            label: "Ticket ID",
        },
        {
            path: "payment",
            label: "Payment",
            content: (data: any) => (
                <DoubleRowContainer>
                    <span>{data.finalAmount} QAR</span>
                    <span>{data.paymentMethod}</span>
                </DoubleRowContainer>
            ),
        },
        ...(hasTransactionOrderId ? [{
            path: "transaction",
            label: "SkipCash ID",
            content: (data: any) => (
                <DoubleRowContainer width="16rem">
                    <span style={{ fontSize: '12px' }}>
                        {data.transaction?.orderId ?? 'NA'}
                    </span>
                </DoubleRowContainer>
            ),
        }] : []),
        {
            path: "product",
            label: "Product",
            content: (data: any) => (
                <DoubleRowContainer width="100%" maxWidth="20rem">
                    {data.items.map((item: any) => (
                        <span style={{ fontSize: '12px' }} key={item._id}>{item.name}</span>
                    ))}
                </DoubleRowContainer>
            ),
        },
    ];

    return (
        <>
            <TableWrapper>
                <TableWithPagination
                    columns={columns}
                    data={data}
                    isTableDataLoading={isTableDataLoading}
                    currentPage={currentPage}
                    totalData={totalProducts}
                    rowsPerPage={limit}
                    onPageChange={onPageChange}
                />
            </TableWrapper>
            <ListWrapper>
                <ListWithPaginationTicket
                    columns={columns}
                    data={data}
                    isTableDataLoading={isTableDataLoading}
                    title={""}
                    hidePagination={false}
                    currentPage={currentPage}
                    totalData={totalProducts}
                    rowsPerPage={limit}
                    onPageChange={onPageChange}
                />
            </ListWrapper>
        </>
    );
};

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 4.5rem;
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
    padding-top: 1rem;
  }
`;

interface DoubleRowContainerProps {
    width?: string;
    maxWidth?: string;
}

const DoubleRowContainer = styled.div<DoubleRowContainerProps>`
  width: ${(props) => props.width || "100px"};
  max-width: ${(props) => props.maxWidth || "100%"};
  display: flex;
  flex-direction: column;
`;

const DoubleRowContainerContact = styled.div<DoubleRowContainerProps>`
  width: ${(props) => props.width || "100px"};
  max-width: ${(props) => props.maxWidth || "100%"};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media only screen and (max-width: 768px) {
    align-items: flex-end;
  }
`;

const MobileContainer = styled.div<DoubleRowContainerProps>`
  width: ${(props) => props.width || "120px"};
  max-width: ${(props) => props.maxWidth || "100%"};
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  @media (min-width: 768px) { 
    justify-content: flex-start;
  }
`;


const SignatureContainer = styled.div`
  position: relative;
  text-align: center;
  > span {
    color: #467cf8;
    text-decoration: underline;
    cursor: pointer;
  }
  > img {
    position: absolute;
    top: -1rem;
    width: 5rem;
    display: none;
  }
  &:hover {
    > img {
      display: block;
    }
  }
  @media only screen and (max-width: 1024px) {
    > img {
      top: -1rem;
      right: 2rem;
      width: 5rem;
    }
  }
`;

export default LwwTicketTable;
